// IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2)
// Состояние вида ячеек отчёта REPORT2 на фронте (§1.5 плана p149): у виджета ОДИН активный вид — WIDGET._cellView (строка, '' = «Числа»).
// Кнопки опций вида (set_menu: view + front_only; бэк T0 добавляет cell_view — канонический id режима, group: 'cell_view', shape; view — прежний id
// строки Options, например status_pie) взаимоисключающие: клик по неактивной включает её вид, клик по активной (или по кнопке numbers) — «Числа».
// Прежняя карта WIDGET._cellViews ({ id: bool }) остаётся «видел ли кнопку» + флаг активности (совместимость cellView_fromLegacy).
// Чистые функции (без Vue и DOM) — tests/unit/cellViewsMerge.test.mjs
import { cellView_key, CELL_VIEW_NUMBERS } from '@/utils/cellViews'

export const CELL_VIEW_GROUP = 'cell_view'

const str = (v) => (v === null || v === undefined ? '' : String(v)).trim()

// кнопка опции вида, которую фронт переключает сам (view + front_only; как cellPie_isViewButton)
export function cellViewBtn_is(btn) {
    return !!(btn && typeof btn === 'object' && (btn.view || btn.cell_view) && btn.front_only)
}
// канонический id вида кнопки: cell_view (T0), иначе view с алиасом (status_pie → status_zones)
export function cellViewBtn_id(btn) {
    if (!btn || typeof btn !== 'object') return ''
    return cellView_key(str(btn.cell_view) || str(btn.view))
}
export function cellViewBtn_group(btn) {
    return str(btn?.group) || str(btn?.params?.group) || CELL_VIEW_GROUP
}

// IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
// вариант кнопки вида: у одного режима может быть несколько кнопок (composition и composition со split_by) — различаются строкой опции (params.group = id / title строки)
export function cellViewBtn_variant(btn) {
    if (!btn || typeof btn !== 'object') return ''
    return str(btn.params?.group) || str(btn.view) || cellViewBtn_id(btn)
}

// вид после клика по кнопке: активная или numbers — '' («Числа»), иначе вид кнопки.
// IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by): activeVar — вариант активной кнопки (WIDGET._cellViewVar); клик по другой кнопке того же режима — режим остаётся (меняется вариант)
export function cellViewState_next(active, btn, activeVar) {
    const id = cellViewBtn_id(btn)
    const cur = cellView_key(active)
    if (id && id === cur && str(activeVar) && cellViewBtn_variant(btn) !== str(activeVar)) return id   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
    if (!id || id === CELL_VIEW_NUMBERS || id === cur) return ''
    return id
}

// карта «видел кнопку» → активен ровно active (прочие false); новая кнопка добавляется
export function cellViewState_seen(seen, active, btns = []) {
    const m = (seen && typeof seen === 'object') ? seen : {}
    for (const b of btns) { const id = cellViewBtn_id(b); if (id && !(id in m)) m[id] = false }
    for (const k of Object.keys(m)) m[k] = cellView_key(k) === active && !!active
    return m
}

// признак active кнопок вида группы cell_view по активному виду (кнопка numbers — активна при «Числах»). → число изменённых кнопок
// IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by): activeVar — вариант активной кнопки; задан — из кнопок одного режима нажата только его
export function cellViewState_mark(btns, active, activeVar) {
    let n = 0
    const want = cellView_key(active) || CELL_VIEW_NUMBERS
    const av = want === CELL_VIEW_NUMBERS ? '' : str(activeVar)   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
    for (const b of (Array.isArray(btns) ? btns : [])) {
        if (!cellViewBtn_is(b) || cellViewBtn_group(b) !== CELL_VIEW_GROUP) continue
        const on = cellViewBtn_id(b) === want && (!av || cellViewBtn_variant(b) === av)   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
        if (!!b.active !== on) { b.active = on; n++ }
    }
    return n
}

// кнопки пришли (ответ set_menu / reload): первое появление кнопки задаёт начальное состояние (active бэка — дефолт отчёта: строка Options use),
// если активного вида ещё нет; дальше — состояние фронта. active — WIDGET._cellView (undefined — ещё не задан). → новый активный вид ('' — «Числа»)
export function cellViewState_sync(active, seen, btns, activeVar) {   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by): + activeVar (вариант активной кнопки) — в cellViewState_mark
    let a = typeof active === 'string' ? cellView_key(active) : undefined
    const m = (seen && typeof seen === 'object') ? seen : {}
    for (const b of (Array.isArray(btns) ? btns : [])) {
        if (!cellViewBtn_is(b)) continue
        const id = cellViewBtn_id(b)
        if (!id || id in m) continue
        m[id] = !!b.active
        if (b.active && !a && id !== CELL_VIEW_NUMBERS) a = id
    }
    if (a === undefined || a === CELL_VIEW_NUMBERS) a = ''
    cellViewState_seen(m, a)
    cellViewState_mark(btns, a, activeVar)   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
    return a
}

// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p191 кола — за натиснутим видом у смузі, без опції «Кругові за статусами»)
// Круги — только за нажатым видом полосы над таблицей; отдельного переключателя в шапке нет. Кнопка вида в ШАПКЕ, чей вид (канонический id) уже
// есть кнопкой в полосе (строка-алиас status_pie «Кругові за статусами» при строке status_zones), — дубль: не показывается, её active (use строки)
// вид не нажимает. Бэк с выключателем not-cell_views_gate_by_view (ВКЛ) таких кнопок уже не шлёт и кладёт все виды в полосу — здесь страховка
// для прежнего бэка. Выключатель fe.ux.cellViewsGateByView (дефолт ВКЛ; ВЫКЛ — прежнее поведение).
export const CELL_VIEW_GATE_FLAG = 'fe.ux.cellViewsGateByView'
export function cellViewGate_on(setting) {   // нет читателя / ошибка — ВКЛ
    try { return typeof setting === 'function' ? setting(CELL_VIEW_GATE_FLAG, true) !== false : true } catch (e) { return true }
}
// кнопки шапки (header) — дубли кнопок полосы (strip): кнопка вида группы cell_view, чей канонический id есть среди кнопок вида полосы. → массив кнопок шапки
export function cellViewBtn_headerDupes(header, strip) {
    const ids = new Set()
    for (const b of (Array.isArray(strip) ? strip : [])) {
        if (cellViewBtn_is(b) && cellViewBtn_group(b) === CELL_VIEW_GROUP) { const id = cellViewBtn_id(b); if (id) ids.add(id) }
    }
    if (!ids.size) return []
    const sset = new Set(Array.isArray(strip) ? strip : [])
    return (Array.isArray(header) ? header : []).filter(b => !sset.has(b) && cellViewBtn_is(b) && cellViewBtn_group(b) === CELL_VIEW_GROUP && ids.has(cellViewBtn_id(b)))
}

// IE 2026 11 02 / ODOO-350449 (p191 правка координатора: use строки status_pie нажимает «Статуси й зони» при открытии)
// порядок кнопок для cellViewState_sync: спрятанные дубли шапки — первыми (их active задаёт начальный вид: первая кнопка вида в карте «видел» решает)
export function cellViewBtn_dupesFirst(btns, dupes) {
    const d = Array.isArray(dupes) ? dupes : []
    const arr = Array.isArray(btns) ? btns : []
    if (!d.length) return arr
    return [...arr.filter(b => d.includes(b)), ...arr.filter(b => !d.includes(b))]
}

// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p191 — опції виглядів однією склеєною групою кнопок, як «Міра» теплокарти)
// Склеенные группы кнопок панели над таблицей: подряд идущие кнопки с одной группой (segment) — один блок, скругление только по краям, разделитель 1 px
// (вид как полоса «Міра» теплокарты, HeatmapSwitches .hm-seg). Группа кнопки — поле segment бэка (колонка «Button group» таблицы опций; пусто — отдельная
// кнопка); поля нет (прежний бэк) — кнопки вида группы cell_view, кроме composition «Підлеглі рядки», в группе 'cell_view'.
// Выключатель fe.ux.optionGroupSegments (дефолт ВКЛ; ВЫКЛ — отдельные чипы, как прежде).
export const OPTION_SEG_FLAG = 'fe.ux.optionGroupSegments'
export function optionSeg_on(setting) {
    try { return typeof setting === 'function' ? setting(OPTION_SEG_FLAG, true) !== false : true } catch (e) { return true }
}
export function optionSeg_key(btn) {
    if (!btn || typeof btn !== 'object') return ''
    if ('segment' in btn) { const sg = str(btn.segment); return sg === '-' ? '' : sg }
    if (cellViewBtn_is(btn) && cellViewBtn_group(btn) === CELL_VIEW_GROUP && cellViewBtn_id(btn) && cellViewBtn_id(btn) !== 'composition') return CELL_VIEW_GROUP
    return ''
}
// классы обёртки кнопки index в списке list (видимы первые maxVisible): { cp-seg, cp-seg-first, cp-seg-last } | null — не в группе (одиночная кнопка группы — тоже null)
export function optionSeg_classes(list, index, maxVisible = Infinity) {
    const arr = Array.isArray(list) ? list : []
    const vis = (i) => i >= 0 && i < arr.length && i < maxVisible
    if (!vis(index)) return null
    const k = optionSeg_key(arr[index])
    if (!k) return null
    const prev = vis(index - 1) && optionSeg_key(arr[index - 1]) === k
    const next = vis(index + 1) && optionSeg_key(arr[index + 1]) === k
    if (!prev && !next) return null
    return { 'cp-seg': true, 'cp-seg-first': !prev, 'cp-seg-last': !next }
}
